import { Google, Pixall } from '../analytics/index.js';
const psxBLPBaseAnalyticsObj = {
  eventSource: 'link',
  eventType: 'click',
  pageId: 'syc_psx_buy',
  pageType: 'own',
  program: 'DealerDotCom'
};

/**
 * @summary Sends Pixall/Google on SYC click events
 */
export function sycClickEvent(_ref, option) {
  let {
    data = {},
    dataLayer
  } = _ref;
  const {
    name: eventName,
    isPixallEvent,
    pixallData = {},
    googleData = {}
  } = data;
  let cmp = eventName;
  let result = null;
  switch (eventName) {
    case 'icoClick':
      cmp = 'syc_cntr_ico';
      result = 'cta::at-sell-my-car::["Get My Offer"]';
      break;
    default:
  }
  if (isPixallEvent) {
    Pixall.sendClickEvent({
      label: cmp,
      eventSource: 'personalization',
      listingType: undefined,
      ...pixallData
    }, dataLayer, option);
  }
  if (result) {
    Google.sendClickEvent({
      eventElement: 'sell-your-car',
      eventResult: result,
      ...googleData
    }, option);
  }
  return {
    cmp
  };
}
function sendGoogleClickEvent(analyticsObject, option) {
  const clickObject = {
    event: 'analytics_event',
    eventElement: analyticsObject.category,
    eventAction: 'click',
    eventResult: analyticsObject.label,
    eventNonInteractive: analyticsObject.eventNonInteractive
  };
  Google.sendClickEvent(clickObject, option);
  return clickObject;
}
function sendPixallClickEvent(pixallEventData, dataLayer, option) {
  if (pixallEventData && Object.entries(pixallEventData || {}).length > 0) {
    Pixall.sendClickEvent(pixallEventData, dataLayer, option);
  }
  return pixallEventData;
}
export function shopPrivateSellerClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const clickObject = {
    category: 'sell-your-car',
    label: 'cta::srp::shop-private-seller',
    eventNonInteractive: false
  };
  const pixallDataObject = {
    label: 'cta::srp::shop-private-seller',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  sendGoogleClickEvent(clickObject, option);
  return clickObject;
}
export function psxSellMyCarClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const clickObject = {
    category: 'sell-your-car',
    label: 'cta::syc::sell-my-car',
    eventNonInteractive: false
  };
  const pixallDataObject = {
    label: 'cta::syc::sell-my-car',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function viewMyDashboardClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'text-link::view-my-dashboard',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::view-my-dashboard',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function shopVerifiedPrivateVehiclesClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'cta::syc::sell-my-car',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::learn-about-our-trusted-community',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function buyOnlineClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'text-link::financing-vehicle-services-contacts-and-gap-insurance-available',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::financing-vehicle-services-contacts-and-gap-insurance-available',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function atPSXStyleCategoryCTAClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: `tile::srp::${data?.carType}`,
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: `tile::srp::${data?.carType}`,
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function identityCheckClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'text-link::stripe-id-check',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::stripe-id-check',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function faqClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'lrn_more_faqs',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::learn-more-on-our-frequently-asked-questions',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function shopAllPrivateSellerCarsClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: 'cta::syc::sell-my-car',
    ...psxBLPBaseAnalyticsObj,
    ...data,
    hasListingType: false
  };
  const clickObject = {
    category: 'sell-your-car',
    label: 'text-link::srp::shop-all-private-seller-cars',
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export function atPrivateSellerCarouselNavigationClick(metadata, option) {
  if (['previous', 'next'].includes(metadata.data.type)) {
    const clickObject = {
      category: 'sell-your-car',
      label: `cta::srp:recently-listed-private-seller::scroll-${metadata.data.type}`,
      eventNonInteractive: false
    };
    sendGoogleClickEvent(clickObject, option);
    return clickObject;
  }
  return {};
}
export function howToSellACarInStateClick(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const pixallDataObject = {
    label: `text-link::how-to-sell-a-car-in::${data?.state}`,
    ...psxBLPBaseAnalyticsObj,
    ...data
  };
  const clickObject = {
    category: 'sell-your-car',
    label: `text-link::how-to-sell-a-car-in::${data?.state}`,
    eventNonInteractive: false
  };
  sendGoogleClickEvent(clickObject, option);
  sendPixallClickEvent(pixallDataObject, dataLayer, option);
  return clickObject;
}
export default {
  sycClickEvent
};